<template>
  <div class="videoitem">
    <div class="title">
      <img src="../assets/image/videotitle.jpg" />
    </div>
    <div class="Con">
      <div class="auto">
        <span id="zl"></span>
        <div>
          <!-- <video width="560" style="background:#000" controls poster="../assets/video/videofm.jpg">
            <source src="../assets/video/movie.mp4" type="video/mp4" />您的浏览器不支持Video标签。
          </video>-->
          <iframe
            height="650"
            width="1200"
            src="http://player.youku.com/embed/XNDQ4NDc3OTUwNA=="
            frameborder="0"
          ></iframe>
        </div>
        <!-- <div class="top">
          <div>
            <img src="../assets/image/tips2_img1.jpg" alt />
          </div>
          <div>
            <video
              width="560"
              height="345"
              style="background:#000"
              controls
              poster="https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2907636791,2187333297&fm=26&gp=0.jpg"
            >
              <source src="../assets/video/movie.mp4" type="video/mp4" />
              <source src="movie.ogg" type="video/ogg" />您的浏览器不支持Video标签。
            </video>
          </div>
          <div>
            <img src="../assets/image/tips2_img2.jpg" alt />
          </div>
        </div>
        <div class="bot">
          <div>
            <img src="../assets/image/tips2_img3.jpg" alt />
          </div>
          <div>
            <img src="../assets/image/tips2_img4.jpg" alt />
          </div>
          <div>
            <img src="../assets/image/tips2_img5.jpg" alt />
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.videoitem {
  float: left;
  width: 100%;
  /* height: 820px; */
  background: #eee;
  padding-bottom: 100px;
}
.videoitem .title {
  float: left;
  width: 100%;
  height: 180px;
  text-align: center;
}
.videoitem .Con {
  float: left;
  width: 100%;
  /* height: 582px; */
}
.videoitem .Con .auto {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  /* height: 582px; */
  padding-bottom: 20px;
}
#zl {
  position: absolute;
  top: 0px;
  width: 100%;
  background: #eee;
  height: 4px;
}
.videoitem .Con .auto div {
  float: left;
  width: 100%;
}
.videoitem .Con .auto div video {
  float: left;
  width: 100%;
}
/* .videoitem .Con .auto .top {
  float: left;
  width: 100%;
  height: 345px;
}
.videoitem .Con .auto .top div {
  float: left;
}
.videoitem .Con .auto .top div img {
  float: left;
}
.videoitem .Con .auto .top div:nth-child(2) {
  position: relative;
  float: left;
  margin-left: 6px;
  width: 560px;
  height: 100%;
  border: 1px solid #777;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
}
.videoitem .Con .auto .top div:nth-child(2) img {
  position: absolute;
  top: 9px;
  left: 11px;
}
.videoitem .Con .auto .top div:last-child {
  float: right;
}
.videoitem .Con .auto .bot {
  position: absolute;
  width: 100%;
  height: 231px;
  left: 0;
  bottom: 0;
}
.videoitem .Con .auto .top div,
.videoitem .Con .auto .bot div {
  overflow: hidden;
}
.videoitem .Con .auto .bot div:hover img,
.videoitem .Con .auto .top div:hover img {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -o-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
}
.videoitem .Con .auto .bot div img,
.videoitem .Con .auto .top div img {
  transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -o-transition: all 0.5s;
  -webkit-transition: all 0.5s;
}
.videoitem .Con .auto .bot div,
.videoitem .Con .auto .bot div img {
  float: left;
}
.videoitem .Con .auto .bot div:nth-child(2) {
  margin: 0 6px 0 4px;
} */
</style>